import React, { Children, Fragment } from 'react';
import PropTypes from 'prop-types';

import ArchiveHeader from '../molecules/archive-header';
import ArchiveResults from '../molecules/archive-results';
import Pagination from '../molecules/pagination';

const Archive = ({
  children,
  items,
  filterItems,
  filterTaxonomy,
  activeFilter,
  titleText,
  selectFilterText,
  clearFilterText,
  closeFilterText,
  openFilterText,
  rootFilterText,
  pagination,
  rootUrl,
  filteredUrl,
  filterOpen,
  toggleFilterClick,
  renderActiveFilter,
  hasNoResults,
  isList,
  isLoading,
  hasErrored,
  renderItems,
  renderCard,
  renderLoadingCard,
  renderError,
  renderNoResults,
  getCardProps,
  hasSimpleHeader,
}) => {
  return (
    <section className="archive container">
      <div className="archive__inner">
        <ArchiveHeader
          titleText={titleText}
          taxonomy={filterTaxonomy}
          urlPrefix={rootUrl}
          items={filterItems}
          activeFilter={activeFilter}
          selectFilterText={selectFilterText}
          rootLink={rootUrl}
          rootText={rootFilterText}
          clearText={clearFilterText}
          openText={openFilterText}
          closeText={closeFilterText}
          filterOpen={filterOpen}
          toggleFilterClick={toggleFilterClick}
          renderActiveFilter={renderActiveFilter}
          isSimple={hasSimpleHeader}
        />
        {!hasErrored && (
          <ArchiveResults
            items={items}
            isList={isList}
            renderItems={renderItems}
            renderCard={renderCard}
            renderLoadingCard={renderLoadingCard}
            getCardProps={getCardProps}
            isLoading={isLoading}
          >
            {children}
          </ArchiveResults>
        )}
        {!isLoading && !hasErrored && hasNoResults && (
          <Fragment>
            {renderNoResults && renderNoResults()}
            {!renderNoResults && <p>No results</p>}
          </Fragment>
        )}

        {!isLoading && !hasErrored && pagination && pagination.pageCount > 1 && (
          <Pagination urlPrefix={filteredUrl} {...pagination} />
        )}
        {!isLoading && hasErrored && (
          <Fragment>
            {renderError && renderError()}
            {!renderError && <p>There has been a problem</p>}
          </Fragment>
        )}
      </div>
    </section>
  );
};

Archive.propTypes = {
  isList: PropTypes.bool,
  renderItems: PropTypes.bool,
  renderCard: PropTypes.func,
  hasNoResults: PropTypes.bool,
  getCardProps: PropTypes.func,
  isLoading: PropTypes.bool,
  hasErrored: PropTypes.bool,
  renderLoadingCard: PropTypes.func,
  renderNoResults: PropTypes.func,
  renderError: PropTypes.func,
  titleText: PropTypes.string,
};

Archive.defaultProps = {
  isList: false,
  renderItems: true,
  hasNoResults: false,
  renderCard: undefined,
  renderLoadingCard: undefined,
  getCardProps: undefined,
  isLoading: false,
  hasErrored: false,
  renderNoResults: null,
  renderError: null,
  hasSimpleHeader: false,
};

export default Archive;
